import { createFileRoute } from '@tanstack/react-router'
import { GroupMonitoringScreen } from '../../../../features/admin/GroupMonitoringScreen'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/monitoring/')({
  component: AdminMonitoringIndexRoute,
})

/* ───── Route Component ───── */

function AdminMonitoringIndexRoute() {
  return <GroupMonitoringScreen />
}
